import { render, staticRenderFns } from "./PacksAccount.vue?vue&type=template&id=029bf052&scoped=true"
import script from "./PacksAccount.vue?vue&type=script&lang=ts"
export * from "./PacksAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029bf052",
  null
  
)

export default component.exports